import { create } from 'zustand'
import { persist } from 'zustand/middleware'

/**
 * The Standort whose purchase orders are shown. Persisted like the deliveries' selection, so a
 * reload or a deep link back from the Bestellvorschlag lands on the same Standort.
 */
interface PurchaseOrderRestaurantState {
  restaurantId: number | null
  setRestaurantId: (id: number | null) => void
}

export const usePurchaseOrderRestaurantStore =
  create<PurchaseOrderRestaurantState>()(
    persist(
      (set) => ({
        restaurantId: null,
        setRestaurantId: (id) => set({ restaurantId: id }),
      }),
      { name: 'purchase-order-restaurant' },
    ),
  )
